export default "__VITE_ASSET__2486c886__"